import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface Commune {
  code: string;
  nom: string;
  codesPostaux?: string[];
  departement?: { code: string; nom: string };
  region?: { code: string; nom: string };
  population?: number;
}

@Injectable({ providedIn: 'root' })
export class GeoApiService {
  private http = inject(HttpClient);
  private base = 'https://geo.api.gouv.fr';

  /**
   * Recherche de communes par nom OU par code postal (si le terme ne contient que des chiffres).
   */
  searchCommunes(term: string, limit = 10): Observable<Commune[]> {
    const trimmed = (term ?? '').trim();
    if (!trimmed) return of([]);

    const isPostal = /^\d{2,5}$/.test(trimmed);

    let params = new HttpParams()
      .set(isPostal ? 'codePostal' : 'nom', trimmed)
      .set('limit', limit.toString())
      .set('boost', 'population')
      .set('fields', 'nom,code,codesPostaux,departement,region,population');

    return this.http.get<Commune[]>(`${this.base}/communes`, { params }).pipe(
      map(list => list ?? []),
      catchError(() => of([])), // tolérant en cas d'erreur réseau/API
    );
  }
}
